import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { BotData } from '@modules/bots/components/bots-crud/bots-crud.types';
import { BotSetupFormState, BotSetupState } from './bot-setup.model';

@Injectable({
  providedIn: 'root',
})
export class BotSetupStateService {
  private formState: BotSetupFormState | null = null;
  private dialogConfig: MatDialogConfig | null = null;
  private botData: BotData | null = null;
  private currentStep = 0;

  saveState(formValue: BotSetupFormState, config: MatDialogConfig, bot: BotData | null, step: number): void {
    this.formState = formValue;
    this.dialogConfig = config;
    this.botData = bot;
    this.currentStep = step;
  }

  getState(): BotSetupState {
    return {
      formValue: this.formState,
      config: this.dialogConfig,
      bot: this.botData,
      step: this.currentStep,
    };
  }

  clearState(): void {
    this.formState = null;
    this.dialogConfig = null;
    this.botData = null;
    this.currentStep = 0;
  }

  hasState(): boolean {
    return this.formState !== null;
  }
}
